import React, { Component } from 'react';
import './engage.css';
import LinkToSlash from './engage/links/LinkToSlash'
import EngageDataControl from './engage/EngageDataControl'


class Engage extends Component {
  render() {
    return (
      <div id="eng-d1a">
        <LinkToSlash id="eng-l1a"
        />
        <div id="eng-d2a">
          not Engage @GirlPosts
        </div>
        <EngageDataControl/>
      </div>
    );
  }
}


export default Engage;


// WEBPACK FOOTER //
// ./src/containers/Engage.js